<template>
  <div class="directory-grid-item">
    <div class="directory-grid-item__inner">
      <a :href="item.url" class="directory-grid-item__title" v-if="item.url">
        {{ item.name }}
      </a>

      <div class="directory-grid-item__title" v-if="!item.url">
        {{ item.name }}
      </div>

      <div class="directory-grid-item__job" v-if="item.job_title">
        {{ item.job_title }}
      </div>

      <ul
        class="directory-grid-item__details ignore-list"
        v-if="hasDetails"
        >
        <li v-if="item.phone">
          <span v-html="assets.phone"/>
          <a :href="`tel:${parsePhoneNumber(item.phone)}`">{{ item.phone }}</a>
        </li>

        <li v-if="item.phone2">
          <span v-html="assets.phone2"/>
          <a :href="`tel:${parsePhoneNumber(item.phone2)}`">{{ item.phone2 }}</a>
        </li>

        <li v-if="item.location">
          <span v-html="assets.mapPin"/>
          <a :href="item.location_url" v-if="item.location_url">
            {{ item.location }}
          </a>

          <div v-if="!item.location_url">
            {{ item.location }}
          </div>
        </li>

        <li v-if="item.email && !item.contact_url">
          <span v-html="assets.email"/>
          <a :href="`mailto:${item.email}`">{{ item.email }}</a>
        </li>

        <li v-if="item.email && item.contact_url">
          <span v-html="assets.email"/>
          <a :href="item.contact_url">Contact {{ item.first_last_name }}</a>
        </li>
      </ul>

      <a :href="item.url" class="directory-grid-item__more" v-html="assets.arrow" v-if="item.url" aria-label="View Details"/>
    </div>
  </div>
</template>

<script>
import { parsePhoneNumber } from 'scripts/common/util'

export default {
  name: 'DirectoryGridItem',

  props: {
    item: {
      type: Object,
      default: () => {}
    },
    assets: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    hasDetails() {
      return this.item.phone || this.item.location || this.item.email
    }
  },

  methods: {
    parsePhoneNumber(number) {
      return parsePhoneNumber(number)
    }
  }
}
</script>
